import { Component, Vue, Mixins } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import { isAxiosError, AxiosErrorHandler } from '@/util/AxiosErrorHandler';
import SBAPI from '@/util/SBAPI';

@Component({
    components: AllComponents(),
})
export default class FaQ extends Mixins(CommonView) {
    public newsList: SBAPI.News[] = [];

    public async created() {
        let newsList = await SBAPI.NewsController.getNewsListUsingGET().catch(AxiosErrorHandler);
        if (isAxiosError(newsList)) {
            return;
        }
        this.newsList = newsList.data
    }
}
